// 261010 UI1a + UI2 — cờ BỀN của một bước (Tài sản, Đạo diễn…, Video): đọc từ `workflow-status` (stepRuns[bước].objects) nên F5 vẫn còn; không lưu ở toast / bộ nhớ.
// Hai nhóm: LỖI (đỏ, chạy lại / bổ sung được) và GIỮ SỬA TAY (trung tính — máy cố ý không ghi đè, KHÔNG phải lỗi, không gợi ý chạy lại).
import React from 'react';
import type { WorkflowEventStatus, WorkflowStepKey } from '../../types/filmWorkflow';
import type { AssetFlagRow, PrimaryCall, SecondaryAction } from './workflowPrimaryPolicy';
import { stepFailSummaryOf } from './stepFailSummary';
import WorkflowStepFailSummary from './WorkflowStepFailSummary';

const Item: React.FC<{ r: AssetFlagRow; orderOf: Map<string, number>; chip: string }> = ({ r, orderOf, chip }) => {
  const vids = r.eventIds.map((id) => orderOf.get(id)).filter((n): n is number => typeof n === 'number').sort((a, b) => a - b);
  return (
    <li>
      <span className={chip}>{r.outcomeLabel}</span>
      <b>{r.typeLabel}</b>
      {r.name ? <span title={r.key} data-testid="wf-flag-name">{r.name}</span> : <span className="mono faint" title={r.key}>{r.key.split(':').pop()?.slice(0, 8)}</span>}
      <span className="msg" title={r.message}>{r.message}</span>
      {vids.length ? <span className="vid">Video {vids.join(', ')}</span> : null}
    </li>
  );
};

interface Props {
  rows: AssetFlagRow[]; events: WorkflowEventStatus[];
  /** UI-errbox: bước + hành động có sẵn của đầu mục + nút chính (để dòng tóm tắt không lặp nút) + lệnh chạy. */
  step: WorkflowStepKey; actions?: SecondaryAction[]; primary?: { call: PrimaryCall | null; secondary?: SecondaryAction[] } | null;
  sending?: boolean; onRun?: (call: PrimaryCall | null) => void;
}

const WorkflowAssetFlags: React.FC<Props> = ({ rows, events, step, actions, primary, sending, onRun }) => {
  if (rows.length === 0) return null;
  const orderOf = new Map(events.map((e) => [e.eventId, e.eventOrder]));
  const errs = rows.filter((r) => r.kind !== 'KEPT');
  const kept = rows.filter((r) => r.kind === 'KEPT');
  // UI-errbox: lỗi = MỘT dòng tóm tắt gom theo loại (không còn hộp đỏ liệt kê); id/testid `wf-step-flags` giữ nguyên cho nút «Xử lý N lỗi».
  const summary = errs.length ? stepFailSummaryOf(errs, orderOf, step, actions ?? [], primary) : null;
  return (
    <>
      {summary ? (
        <section id="wf-step-flags" aria-label="Mục còn lỗi của bước" data-testid="wf-step-flags">
          <WorkflowStepFailSummary summary={summary} sending={!!sending} onRun={onRun ?? (() => undefined)} />
        </section>
      ) : null}
      {kept.length ? (
        <section className="wf-flags wf-kept" id={summary ? undefined : 'wf-step-flags'} aria-label="Mục giữ nguyên bản sửa tay" data-testid="wf-step-kept">
          <h3>{kept.length} mục giữ nguyên bản sửa tay — máy không ghi đè</h3>
          <ul>{kept.map((r) => <Item key={r.key} r={r} orderOf={orderOf} chip="wf-chip" />)}</ul>
        </section>
      ) : null}
    </>
  );
};

export default WorkflowAssetFlags;
